import { Details, DetailsRow } from 'symbiosis-uikit'
import Spinner from '~/components/Spinner'
import Typography from '~/components/Typography'
import { SIS_DECIMALS } from '~/lib/SISDecimals'
import { Rewards } from '~/pages/CrossChainFarmPage/types'
import styles from './TotalRewardsBalance.pcss'
import { getFormattedSISValue } from './utils'
import { getFormattedValue } from '~/lib/getFormattedValue'
import { VeSIS } from '~/components/VeSIS'

interface Props {
	children: React.ReactNode
	pending: boolean
	totalRewards?: Rewards
}

function TotalRewardsBalance({ children, pending, totalRewards }: Props) {
	return (
		<div className={styles.container}>
			<Typography
				className={styles.title}
				size="M"
				tag="div"
				color="gray"
			>
				Total available to claim:
			</Typography>

			<Typography className={styles.available} size="XL" tag="div">
				{pending ? (
					<Spinner className={styles.spinner} />
				) : (
					<div>
						{getFormattedValue(
							totalRewards?.totalAvailableToClaim,
							SIS_DECIMALS
						)}
					</div>
				)}
				<div>SIS</div>
			</Typography>

			{children}

			<Details className={styles.details}>
				<DetailsRow
					label="Total rewards claimed:"
					loading={pending}
					value={getFormattedSISValue(
						totalRewards?.totalRewardsClaimed
					)}
				/>
			</Details>

			<VeSIS threshold={totalRewards?.vesisThreshold} />
		</div>
	)
}

export default TotalRewardsBalance
